/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/099-floppy-disk': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M14 0H0v16h16V2l-2-2zM8 2h2v4H8V2zm6 12H2V2h1v5h9V2h1.172l.828.828V14z"/>'
  }
})
